import React from 'react';
import { Polyline, Marker, InfoBox } from '@react-google-maps/api';
import _ from 'lodash';
import { selectedStopIconSvg, stopIconSvg, userIconSvg, taskCountSvg, smallChequeredFlag } from './constants';
import { createArrayOfLinesFromLocations, getSequence } from './helper';
import styles from './map.module.css';

/* global google */

export function StopMarker({
  stopId,
  stopSequence,
  tasksCount,
  location,
  hideSequence,
  isStopSelected,
  onStopClick,
  clusterer,
  isMarkersOutSideCluster,
}) {
  const sequence = hideSequence || !stopSequence || stopSequence.length === 0 ? '' : `${getSequence(stopSequence)}`;
  const icon = isStopSelected ? selectedStopIconSvg() : stopIconSvg();
  const onMarkerClicked = React.useCallback(() => {
    onStopClick(stopId);
  }, [stopId]);
  return (
    <div className="marker_class">
      <Marker
        clusterer={clusterer}
        icon={{
          url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icon)}`,
          anchor: new google.maps.Point(20, 40),
          // origin: new google.maps.Point(0, 0),
          // labelOrigin: new google.maps.Point(50, 10),
          strokeWeight: 8,
        }}
        label={{
          className: styles.stop_marker_label,
          text: stopId,
        }}
        position={location}
        onClick={onMarkerClicked}
        id={stopId}
        // title={stopId}
        noRedraw
      >
        {isMarkersOutSideCluster ? (
          <>
            {tasksCount ? (
              <InfoBox
                position={location}
                options={{ closeBoxURL: '', enableEventPropagation: true, pixelOffset: new google.maps.Size(-25, -55) }}
              >
                <>
                  <img
                    src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(taskCountSvg)}`}
                    style={{}}
                    height="33px"
                    width="29px"
                  />
                  <div
                    id="marker-label"
                    style={{
                      color: 'white',
                      top: '-21px',
                      left: `${tasksCount < 9 ? '12px' : '8px'}`,
                      position: 'relative',
                    }}
                  >
                    {tasksCount}
                  </div>
                </>
              </InfoBox>
            ) : null}
            {sequence ? (
              <InfoBox
                position={location}
                options={{ closeBoxURL: '', enableEventPropagation: true, pixelOffset: new google.maps.Size(0, -50) }}
              >
                <>
                  <div
                    style={{
                      height: '20px',
                      minWidth: '30px',
                      margin: '3px 15px 10px 6px',
                      padding: '2px 10px 2px 2px',
                      borderRadius: '20px',
                      border: 'solid 1px #114477',
                      backgroundColor: '#c8e3fd',
                      top: '16px',
                      left: '25px',
                      display: 'flex',
                    }}
                  >
                    <div
                      style={{
                        background: '#114477',
                        width: '15px',
                        borderRadius: '50%',
                        margin: '0px 2px 0px 0px',
                        padding: '2px 4px 1px',
                      }}
                    >
                      <img
                        src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(smallChequeredFlag)}`}
                        height="10px"
                        width="8px"
                      />
                    </div>
                    <div>{sequence}</div>
                  </div>
                </>
              </InfoBox>
            ) : null}
          </>
        ) : null}
      </Marker>
    </div>
  );
}

export function UserMarker({ location, markerLabel, areUsersSelected, clusterer, id }) {
  return (
    <Marker
      clusterer={clusterer}
      icon={{
        url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(userIconSvg(areUsersSelected))}`,
        anchor: new google.maps.Point(15, 40),
        labelOrigin: new google.maps.Point(50, 10),
      }}
      position={location}
      // options={{ anchorPoint: new google.maps.Point(-35, 28) }}
      // labelStyle={{
      //   backgroundColor: 'white',
      //   fontSize: '12px',
      //   padding: '10px',
      //   borderRadius: '15px',
      //   fontFamily: 'JoynFontBook',
      // }}
      label={{
        fontSize: '12px',
        fontFamily: 'JoynFontBook',
        text: markerLabel,
        className: styles.user_marker_label,
      }}
      title={id}
      noRedraw
    >
      {/* <InfoWindow position={location} anchor={new google.maps.Point(-35, 28)}>
        <div>{markerLabel}</div>
      </InfoWindow> */}
    </Marker>
  );
}

function doesLineHaveCorrectValues(line) {
  return (
    !_.isNil(_.get(line, '0.lat')) &&
    !_.isNil(_.get(line, '0.lng')) &&
    !_.isNil(_.get(line, '1.lat')) &&
    !_.isNil(_.get(line, '1.lng'))
  );
}

export const CustomPolyLine = React.memo(function CustomPolyLine({
  strokeColor,
  strokeOpacity,
  strokeWeight,
  locations,
  icons,
}) {
  const lines = createArrayOfLinesFromLocations(locations);
  return lines.map((line, index) => {
    if (!doesLineHaveCorrectValues(line)) return null;
    console.log('options', {
      strokeColor,
      strokeOpacity,
      strokeWeight,
      icons: [
        ...(icons || []),
        {
          icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW, strokeOpacity: 1, scale: 2 },
          offset: '50%',
          repeat: '1',
        },
      ],
    });
    return (
      <Polyline
        key={`${line[0].lat}_${line[0].lng}_${line[1].lat}_${line[1].lng}_${index}`}
        path={line}
        geodesic
        options={{
          strokeColor,
          strokeOpacity,
          strokeWeight,
          icons: [
            ...(icons || []),
            {
              icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW, strokeOpacity: 1, scale: 2 },
              offset: '50%',
              repeat: '1',
            },
          ],
        }}
      />
    );
  });
});
